import { pickPath } from 'hb-react/shared/utils/api/pickPath';

export const fetchNewsPublishedPath = ({
  newsId,
  topicId,
  userId,
  whiteLabelEnabled = false,
  flagEvNewsRevamp = false,
}: {
  flagEvNewsRevamp?: boolean;
  newsId: number | string;
  topicId?: number | null;
  userId?: number | null;
  whiteLabelEnabled?: boolean;
}) => {
  if (flagEvNewsRevamp) {
    return pickPath({
      userId,
      topicId,
      isWLTopic: whiteLabelEnabled,
      paths: {
        networkFO: Routes.private_frontoffice_news_path,
        networkPO: Routes.private_publicoffice_news_path,
        topicFO: Routes.private_frontoffice_topics_news_path,
        topicPO: Routes.private_publicoffice_topics_news_path,
      },
    })(newsId);
  } else {
    const params = topicId
      ? { topic_id: topicId, format: 'json' }
      : { format: 'json' };

    if (whiteLabelEnabled) {
      return Routes.network_letter_path(newsId, params);
    }

    if (topicId && !userId) {
      return Routes.topic_po_news_post_path(topicId, newsId, {
        format: 'json',
      });
    }

    if (topicId) {
      return Routes.topics_topic_news_path(topicId, newsId, { format: 'json' });
    }

    return Routes.network_letter_path(newsId, params);
  }
};
